import React, { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Btn, H3, H6, Image, P } from "../AbstractElements";
import { dynamicImage } from "../Utils";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import {
  CreateAccount,
  DontHaveAccount,
  EmailAddress,
  FacebookLink,
  ForgotPassword,
  LinkedIn,
  Password,
  RememberPassword,
  SignIn,
  SignInAccount,
  SignInWith,
  TwitterLink,
} from "../Utils/Constants";
import FeatherIconCom from "../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import { postData } from "../CommonElements/Functions/PostGetFun";
import { setItem } from "../Utils/StorageHelper";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux-toolkit/store";
import { API } from "../api/API";
import { getData } from "../CommonElements/Functions/PostGetFun";
import { setUserData } from "../redux-toolkit/reducers/UserDatareducer";
import { saveUserDataSeparately } from "../Utils/saveUserDB";
import Dexie, { Table } from "dexie";

export default function SignInForm() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [companyCode, setCompanyCode] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const ssoToken = queryParams.get("appToken");
    const ssoServerUrl = queryParams.get("serverUrl");

    if (ssoToken) {
      // SSO login: token passed directly from Dashboard app — no login API call needed
      localStorage.clear();
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("appToken", ssoToken);
      if (ssoServerUrl) localStorage.setItem("serverUrl", ssoServerUrl);

      // Navigate directly — FirstLoader will fetch all master data fresh using the token
      navigate("/firstLoader");
    } else {
      // Normal login flow
      localStorage.clear();
      const envUrl = "https://sfa.nitiapp.com/";
      if (envUrl) {
        localStorage.setItem("serverUrl", envUrl);
      }
    }
  }, []);


  const serverUrl = localStorage.getItem("serverUrl");
  console.log("serverUrl", serverUrl);
  const dispatch = useDispatch<AppDispatch>();
  const toggle = () => setPasswordVisible(!isPasswordVisible);

  const handleCompanyCodeSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!companyCode) {
      toast.error("Please enter company code");
      return;
    }

    setLoading(true);
    try {
      let resolvedBaseUrl = "https://sfa.nitiapp.com/";

      const url = `https://router.nitiapp.com/`;
      const res = await getData(url, false, { company: companyCode });

      if (res.status === 200 && res.data?.data) {
        const companyData = res.data.data;
        const baseUrlCandidate = companyData.AppBaseUrl && String(companyData.AppBaseUrl).trim() || resolvedBaseUrl;
        resolvedBaseUrl = baseUrlCandidate.endsWith('/') ? baseUrlCandidate : `${baseUrlCandidate}/`;

        const companyId = companyData.CompanyId;
        const companyLogoId = companyData.CompanyLogo;
        const chanakyaUrl = companyData.ChanakyaUrl;

        localStorage.setItem("serverUrl", resolvedBaseUrl);
        localStorage.setItem("scannerBaseUrl", resolvedBaseUrl);
        localStorage.setItem("company_code", companyCode);

        if (companyId) localStorage.setItem("company_id", String(companyId));
        if (companyLogoId) localStorage.setItem("company_logo_id", String(companyLogoId));
        if (chanakyaUrl) localStorage.setItem("chanakyaUrl", String(chanakyaUrl));

        setStep(1);
      } else {
        toast.error(res.data?.message || res.data?.error || "Invalid company code");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const performLogin = async (loginEmail: string, loginPassword: string, sUrl: string | null) => {
    setLoading(true);
    toast.success("Login request sent!");
    await Dexie.delete("DynamicDB");
    localStorage.removeItem("schema_Employee");

    const url = `${sUrl}${API.login}`;
    const { status, data } = await postData(url, false, {
      username: loginEmail,
      password: loginPassword,
    });

    console.log("Full API response:", data);

    if (status === 200 && data.data?.AppToken) {
      const token = data.data.AppToken;

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("appToken", token);

      const rawEmployee = data.data?.employee;
      const employee = Array.isArray(rawEmployee)
        ? rawEmployee[0]
        : rawEmployee;

      console.log("Login Data:", data.data);

      if (employee?.EmployeeId)
        localStorage.setItem("empId", String(employee.EmployeeId));
      if (employee?.PositionId)
        localStorage.setItem("positionId", String(employee.PositionId));
      if (employee?.OrgUnitId)
        localStorage.setItem("orgUnitId", String(employee.OrgUnitId));
      if (employee?.EmployeeCode)
        localStorage.setItem("employeeCode", String(employee.EmployeeCode));
      toast.success(data.message || "Login Success...!");
      navigate(`/firstLoader`);
    } else {
      toast.error(data.message || "Invalid username or password");
      setLoading(false);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    await performLogin(email, password, serverUrl);
  };

  return (
    <div>
      <div>
        <Link className="logo" to={`/admin`}>
          <Image
            className="img-fluid for-light"
            src={dynamicImage(`logo/logo-1.png`)}
            alt="loginpage"
            style={{ width: "200px" }}
            body={true}
          />
        </Link>
      </div>
      <div className="login-main border shadow">
        {step === 0 ? (
          <Form className="theme-form" onSubmit={handleCompanyCodeSubmit}>
            <H3>{"Enter Access Code"}</H3>
            <P>{"Use the code sent by your company to access"}</P>
            <FormGroup>
              <Col>
                <Label>{"Company Code"}</Label>
              </Col>
              <Input
                type="text"
                placeholder="Enter company code"
                value={companyCode}
                onChange={(event) => setCompanyCode(event.target.value)}
              />
            </FormGroup>
            <div className="mb-0 form-group">
              <div className="text-end mt-3">
                <Btn
                  color="primary"
                  className="btn-block w-100"
                  disabled={loading}
                >
                  {loading ? "Verifying..." : "Submit"}
                </Btn>
              </div>
            </div>
          </Form>
        ) : (
          <Form className="theme-form" onSubmit={handleSubmit}>
            <H3>{SignInAccount}</H3>
            <P>{"Enter your email & password to login"}</P>
            <FormGroup>
              <Col>
                <Label>{EmailAddress}</Label>
              </Col>
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Col>
                <Label>{Password}</Label>
              </Col>
              <div className="form-input position-relative">
                <Input
                  type={isPasswordVisible ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  name="login[password]"
                />
                <div className="show-hide" onClick={toggle}>
                  <span className={!isPasswordVisible ? "show" : ""}></span>
                </div>
              </div>
            </FormGroup>
            <div className="mb-0 form-group">
              <div className="text-end mt-3">
                <Btn color="primary" className="btn-block w-100" disabled={loading}>
                  {loading ? "Logging in..." : SignIn}
                </Btn>
              </div>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
}
